export const ADMIN = 'ADMIN'
export const APPROVED = 'APPROVED'
